import { OWNERSHIP_TYPE } from 'Deer/intent/Goals/components/MetaFilters';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const getGoalsCascadedViewApi = ({
  cohort,
  groupByKeys,
  splitByKeys,
  orderBy,
  timeBounds,
  attributeFilter,
  isHierarchyView,
  pageType,
  isTreeView,
  mergeColumns,
  ownership,
}) => {
  const url = endpoints.analytics.goal.cascadedView;

  let includeOwnerTypes;
  if (ownership === OWNERSHIP_TYPE.OWNER) {
    includeOwnerTypes = ['OWNER'];
  }
  if (ownership === OWNERSHIP_TYPE.OWNER_AND_COLLABORATOR) {
    includeOwnerTypes = ['OWNER', 'COLLABORATOR'];
  }

  const body = {
    groupByKeys,
    splitByKeys,
    orderBy,
    timeBounds,
    attributeFilter,
    includeOwnerTypes,
  };

  body.cohortId = cohort?.id;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      isHierarchyView,
      pageType,
      isTreeView,
      mergeColumns,
    },
    body,
  });
};

export const getGoalsTreeViewApi = ({
  cohort,
  groupByKeys,
  splitByKeys,
  orderBy,
  timeBounds,
  attributeFilter,
  pageType,
  ownership,
}) => {
  const url = endpoints.rabbitGoals.treeView;
  let includeOwnerTypes;
  if (ownership === OWNERSHIP_TYPE.OWNER) {
    includeOwnerTypes = ['OWNER'];
  }
  if (ownership === OWNERSHIP_TYPE.OWNER_AND_COLLABORATOR) {
    includeOwnerTypes = ['OWNER', 'COLLABORATOR'];
  }

  const body = {
    groupByKeys,
    splitByKeys,
    orderBy,
    timeBounds,
    attributeFilter,
    includeOwnerTypes,
  };

  body.cohortId = cohort?.id;
  if (cohort?.teamId) {
    body.teamId = cohort?.teamId;
  }

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      pageType,
    },
    body,
  });
};

export const getDepartmentChildFunctionsIdsApi = ({ functionId }) => {
  const url = endpoints.rabbitGoals.childFunctionIds(functionId);

  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getDepartmentHierarchy = () => {
  const url = endpoints.rabbitGoals.departmentHierarchy;

  return sendRequest({
    url,
    credentials: 'include',
  });
};
